import axios from "axios"

export function getBoxDetail (uuid) {
  return new Promise((resolve, reject) => {
    axios.get(`/distributor/admin/api/v1/inventory/box/${uuid}`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data))
  })
}